import { useState } from "react";
import {
  Button,
  IconButton,
  TextField,
  Typography,
  Grid,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useUsername } from "../../hooks/users/useUsername";
import theme from "../../styles/styleTheme";
import { useUserAuth } from "../../context/UserAuthContext";
import NAV from "../../utils/nav.const";
import { useTranslation } from "react-i18next";

const ForgotPassword = () => {
  const { t } = useTranslation();
    const navigate = useNavigate();
    const { forgotPassword } = useUserAuth();
  const [email, setEmail] = useState<string>("");
  const [emailError, setEmailError] = useState<boolean>(false);

  const handleForgotPasswordSubmit = async () => {
    try {
      if (!isValidEmail(email)) {
        setEmailError(true);
        return;
      }
      await forgotPassword(email);
      setEmail("");
      navigate("/" + NAV.FORGOT_PASSWORD_CONFIRMATION);
    } catch (err) {}
  };

  const isValidEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      flexDirection={"column"}
      height={"80vh"}
      maxWidth={"100%"}
      margin={"0 1rem"}
      boxSizing={"border-box"}
    >
        <Box
            display={"flex"}
            gap={"0.3125rem"}
            flexDirection={"column"}
            paddingBottom={"0.9375rem"}
            width="50rem"
            maxWidth={"100%"}
            sx={{
              backgroundColor: "#fff",
              padding: "2rem",
              borderRadius: "16px",
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
            }}
        >
            <Grid display={"flex"} container spacing={2}>
            <Grid display={"flex"} alignItems={"center"} item xs={12}>
                <IconButton
                color="primary"
                onClick={() => navigate("/" + NAV.SIGNIN)}
                >
                <ArrowBackIcon />
                </IconButton>

                <Typography fontWeight={"bold"}>{t("signin.forgot_password")}</Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography dangerouslySetInnerHTML={{ __html: t('signin.forgot_password_description') }} />
            </Grid>
            <Grid item xs={12}>
                <Typography
                variant="body2"
                sx={{
                    opacity: emailError ? 1 : 0,
                    color: theme.palette.primary.main,
                }}
                fontWeight={"bold"}
                >
                Je moet een geldig e-mailadres opgeven
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <TextField
                color="primary"
                fullWidth
                id="email"
                label="Email"
                variant="outlined"
                placeholder="example@gohome.nl"
                value={email}
                onKeyPress={(event) => {
                    if (event.key === "Enter") {
                    handleForgotPasswordSubmit();
                    }
                }}
                onChange={(e) => {
                    setEmail(e.target.value);
                    setEmailError(false);
                }}
                />
            </Grid>
            <Grid display={"flex"} justifyContent={"flex-end"} item xs={12}>
                <Button
                disableRipple
                variant="contained"
                onClick={handleForgotPasswordSubmit}
                disabled={email.trim() === "" ? true : false}
                sx={{
                    color: "#fff",
                }}
                >
                Versturen
                </Button>
            </Grid>
            </Grid>
        </Box>
    </Box>
  );
};

export default ForgotPassword;
